import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  AngularResizeElementDirection,
  AngularResizeElementEvent,
} from "angular-resize-element";
import { Subscription } from "rxjs";
import { FilterService } from "src/app/services/filter.service";
import { DashboardService } from "src/app/services/dashboard.service";
import { EnhancementService } from "src/app/services/enhancements-service";
import { NavigationService } from "src/app/services/navigation.service";
import moment from "moment";
import _, { has, head } from "lodash";
import { MatDialog } from "@angular/material/dialog";
import { DialogService } from "src/app/services/dialog.service";
import { MailPopupComponent } from "./mail-popup/mail-popup.component";
import { EmailService } from "src/app/services/email-service";
import { PreviewMailComponent } from "./preview-mail/preview-mail.component";
import { DialogRef } from "@angular/cdk/dialog";
import { log } from "console";

@Component({
  selector: "app-secure-mail",
  templateUrl: "./secure-mail.component.html",
  styleUrls: ["./secure-mail.component.scss"],
})
export class SecureMailComponent {
  @Input() pageType: string = "sidebar";
  @Output() mailSelected = new EventEmitter<string>();
  @Output() isNewMailOpened = new EventEmitter<boolean>();

  selectedMailId: string = "";
  DialogService: any;
  isTemplatesVisible: boolean = false;
  searchText: string = "";
  selectedTab: string = "";
  inboxCount = 9;
  sentCount = 5;
  totalMails = 20;
  inboxEmails: any[] = [];
  sentEmails: any[] = [];
  isLoading: boolean = false;
  sortOrder: "asc" | "desc" = "asc";
  isMailHeaderVisible: boolean = true;

  @Input("offcanvasRightMailView") offcanvasRightMailView: any;
  @Input("mailIndication") mailIndication: any;
  @Input("notesConfiguration") notesConfiguration: any;

  @Output("onResizeSideWindow") onResizeSideWindow = new EventEmitter<any>();

  public readonly AngularResizeElementDirection = AngularResizeElementDirection;
  public onResizeSide(evt: AngularResizeElementEvent): void {
    this.data.width = evt.currentWidthValue;
    this.data.height = evt.currentHeightValue;
    this.data.top = evt.currentTopValue;
    this.data.left = evt.currentLeftValue;
    this.onResizeSideWindow.emit(this.data);
  }
  emails: any[] = [];
  mails: any[] = [];
  public data: any = {};

  // Dropdown state for mail action button
  isMailDropdownOpen: boolean = false;
  accessPermission: boolean = false;

  constructor(
    private dialogService: DialogService,
    public dialog: MatDialog,
    private dashboardService: DashboardService,
    private enhancementService: EnhancementService,
    private filterService: FilterService,
    private navigationService: NavigationService,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    public emailService: EmailService
  ) {}

  ngOnInit(): void {
    this.onTabChange("inbox"); // Set default tab to inbox
    this.authPermission();
  }

  authPermission() {
    // this.accessPermission = this.emailService.accessPermission;
    this.accessPermission = true;
  }

  async onTabChange(tab: any) {
    this.selectedTab = tab;
    this.searchText = "";
    this.emails = [];
    this.isLoading = true;

    try {
      if (tab === "sent") {
        this.sentEmails = await this.emailService.getSentEmails();
        this.emails = [...this.sentEmails];
        this.emailService.isSentTabSelected = true;
      } else if (tab === "inbox") {
        this.inboxEmails = await this.emailService.getEmails();
        this.emails = [...this.inboxEmails];
        this.emailService.isSentTabSelected = false;
      }

      if (this.pageType === "fullscreen" && this.emails.length > 0) {
        this.openMailPreview(this.emails[0]?.id);
      }
    } catch (error) {
      console.error("Failed to load emails", error);
    } finally {
      this.isLoading = false;
    }
  }

  openMailpopup(pageType: string): void {
    // console.log("new mail Page Type:", pageType); // Debugging
    if (pageType === "sidebar") {
      let dialogRef = this.dialog.open(MailPopupComponent, {
        width: "80%",
        height: "90%",
        disableClose: false,
        panelClass: "du-custom-modalbox",
        data: "comment",
      });
    } else if (pageType === "fullscreen") {
      this.isNewMailOpened.emit(true);
      return;
    }
  }
  sortEmailsByDate(): void {
    if (this.emails && this.emails.length > 0) {
      this.emails.sort((a, b) => {
        const dateA = new Date(a.receivedDateTime).getTime();
        const dateB = new Date(b.receivedDateTime).getTime();
        return this.sortOrder === "asc" ? dateA - dateB : dateB - dateA;
      });
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      // console.log("Emails sorted by date:", this.emails);
    }
  }

  openMailPreview(mailId: string): void {
    this.selectedMailId = mailId;

    if (this.pageType === "fullscreen") {
      this.mailSelected.emit(mailId);
      return;
    }

    const dialogRef = this.dialog.open(PreviewMailComponent, {
      width: "80%",
      height: "90%",
      disableClose: false,
      panelClass: "du-custom-modalbox",
      data: {
        mailId: this.selectedMailId,
        pageType: "sidebar",
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.selectedMailId = "";
    });
  }
  getRecipientsAddresses(mail: any): string {
    if (!mail?.toRecipients) return "";
    return mail.toRecipients
      .map((r: any) => r.emailAddress?.address)
      .join(", ");
  }

  getRecipientsNames(mail: any): string {
    if (!mail?.toRecipients) return "";
    return mail.toRecipients.map((r: any) => r.emailAddress?.name).join(", ");
  }

  goEmailExtracts(): void {
    let query: any = {
      tab_id: 0,
      // cl_key: this.clientKey,
      // md_key: this.moduleKey,
      ds_key: "20251202133154",
    };
    this.navigationService.routerNavigate(
      // `dashboard/${this.moduleName}/${"direct"}/${"Email Extracts"}`,
      `dashboard/Task Management/${"direct"}/${"Email Extracts"}`,
      query
    );
  }

  /**
   * Toggle Mail dropdown - Simple approach
   */
  toggleMailDropdown(): void {
    this.isMailDropdownOpen = !this.isMailDropdownOpen;
  }

  /**
   * Close Mail dropdown
   */
  closeMailDropdown(): void {
    this.isMailDropdownOpen = false;
  }
}
